import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import First from "../assets/images/first.png";
import Second from "../assets/images/second.png";
import Third from "../assets/images/third.png";
import Fourth from "../assets/images/fourth.png";
import First1 from "../assets/images/first1.png";
import Second1 from "../assets/images/second1.png";
import Third1 from "../assets/images/third1.png";
import Fourth1 from "../assets/images/fourth1.png";

//christmas icons
import FirstChristmas from "../assets/images/firstChristmas.svg";
import SecondChristmas from "../assets/images/secondChristmas.svg";
import ThirdChristmas from "../assets/images/thirdChristmas.svg";
import FourthChristmas from "../assets/images/fourthChristmas.svg";

//candyland
import FirstCandyland from "../assets/images/firstCandyland.svg";
import SeconCandyland from "../assets/images/secondCandyland.svg";
import ThirdCandyland from "../assets/images/thirdCandyland.svg";
import FourthCandyland from "../assets/images/fourthCandyland.svg";
import * as htmlToImage from 'html-to-image';
import { saveAs } from 'file-saver';
import { Store } from 'react-notifications-component'

import "../assets/styles/Result.scss";
const Results = () => {
    const history = useNavigate();
    const [scoreToDisplay, setScoreToDisplay] = useState([]);
    const [players, setPlayers] = useState([]);
    const [isDisplay, setIsDisplay] = useState(false);
    const body = document.body;
    

    let Fir = First;
    let Sec = Second;
    let Thi = Third;
    let Fou = Fourth;

    if(body.classList.contains('spooky')){
        Fir = First1;
        Sec = Second1;
        Thi = Third1;
        Fou = Fourth1;
    }
    if(body.classList.contains('christmas')){
        Fir = FirstChristmas;
        Sec = SecondChristmas;
        Thi = ThirdChristmas;
        Fou = FourthChristmas;
    }
    if(body.classList.contains('candyland')){
        Fir = FirstCandyland;
        Sec = SeconCandyland;
        Thi = ThirdCandyland;
        Fou = FourthCandyland;
    }
 
    useEffect(() => {
        const game_data = localStorage.getItem("game_data");
        const player_data = localStorage.getItem("player_data");
        const agreed = localStorage.getItem("agreed");

        if(game_data === null || game_data.length < 1) {
             if(agreed){
                history('/players');
            }
            else{
                history('/');
            }
        }

        if(game_data) {
            // setGame(JSON.parse(game_data))
        }

        if(player_data) {
            setPlayers(JSON.parse(player_data))
        }
 

    },[history])

    const setThemeColor = async () => {
        const body = document.body;
        let themeColor = '#A9B892';   
        if(body.classList.contains('spooky')){
          themeColor = '#F68A43';
        }           
        const metaThemeColor = document.querySelector('meta[name="theme-color"]');
        if (metaThemeColor) {
          metaThemeColor.setAttribute('content', themeColor);
        }
      };

    useEffect(() => {        
        setThemeColor();
        window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', setThemeColor);
        return () => {
          window.matchMedia('(prefers-color-scheme: dark)').removeEventListener('change', setThemeColor);
        };
      }, []); 

    useEffect(() => {
        if (!players.length) return;

        const storedScore = localStorage.getItem("scoreData");
        if (!storedScore) return;

        const parsedScore = JSON.parse(storedScore);
        let final = players.map(player => {
            const scores = parsedScore[player.id] || Array(18).fill(0);

            const total = scores.reduce((sum, val) => sum + val, 0);

            return {
                player: player.id,
                score: total,
                scoresArray: scores  
            };
        });
        final.sort((a, b) => a.score - b.score);
        const breakTie = (a, b) => {
            const last9A = a.scoresArray.slice(9).reduce((s, v) => s + v, 0);
            const last9B = b.scoresArray.slice(9).reduce((s, v) => s + v, 0);
            if (last9A !== last9B) return last9A - last9B;
            const last6A = a.scoresArray.slice(12).reduce((s, v) => s + v, 0);
            const last6B = b.scoresArray.slice(12).reduce((s, v) => s + v, 0);
            if (last6A !== last6B) return last6A - last6B;
            const last3A = a.scoresArray.slice(15).reduce((s, v) => s + v, 0);
            const last3B = b.scoresArray.slice(15).reduce((s, v) => s + v, 0);

            return last3A - last3B;
        };

        final.sort((a, b) => {
            if (a.score !== b.score) return a.score - b.score;
            return breakTie(a, b);
        });

        setScoreToDisplay(final);

    }, [players]);
 
    const endAll = () => {
        localStorage.setItem("game_data","");
        localStorage.setItem("player_data","");        
        localStorage.setItem("agreed", false);
        localStorage.setItem("scoreData", ''); 
        history("/")
    }

    const today = new Date();
    const date = today.toLocaleString('default', { month: 'long', year: "numeric", day: "2-digit"});    


    const runShare = async () => {
        
        setIsDisplay(true);
        const filter = (node) => {
            const exclusionClasses = ['remove-me'];
            return !exclusionClasses.some((classname) => node.classList?.contains(classname));
        }
        Store.addNotification({
            title: "Downloaded",
            message: 'Result screen downloaded successfully.',
            type: "success",
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
              duration: 4000,
              onScreen: true,
              click: true,
              showIcon: true,
              pauseOnHover: true
            }
        });

        htmlToImage.toBlob(document.getElementById('resultScreen'), {filter: filter})
        .then(function (blob) {
            if (window.saveAs) {
            window.saveAs(blob, 'resultScreen.png');
            setIsDisplay(false);
            } else {
            saveAs(blob, 'resultScreen.png');
            setIsDisplay(false);
        }
        });          
    }
    useEffect(() => {
        const handleClassChange = () => {
          const body = document.body;            
          const metaThemeColor = document.querySelector('meta[name="theme-color"]');
          if (body.classList.contains('spooky')) {   
            console.log('---changin theme----')     
            metaThemeColor.setAttribute('content', '#F68A43');        
          } else {
              metaThemeColor.setAttribute('content', '#A9B892');        
          }
        };
    
        // MutationObserver to watch for changes in body class attribute
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
              handleClassChange(); // Call your handler function when class changes
            }
          });
        });
    
        observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    
        // Cleanup observer on component unmount
        return () => {
          observer.disconnect();
        };
      }, []);
    return <div className="VP-view-result" id="resultScreen">
        <div className="view-result-content">
                <h1>LEADERBOARD<br/><span className="date" style={{display: `${ isDisplay ? 'block' : 'none'}`}}>{date}</span></h1>
                <p className="congo" style={{display: `${ isDisplay ? 'block' : 'none'}`}}>Congrats! Putt Putt Champions</p>
                <p className="remove-me" >Last on the scorecard picks up the bill at the Bistro?!</p> 
                <p className="remove-me" >Satisfy your cravings post-game with<br/>woodfired pizza and refreshing beverages.</p>

            {
                scoreToDisplay.map( (data, index) => <div className="scoreRow">
                <div className="firstDiv" key={data.player}>
                    <img src={ index === scoreToDisplay.length-1 && scoreToDisplay.length > 1 ? Fou : index === 0 ? Fir : index === 1 ? Sec : index === 2 ? Thi : index === 3 ? Fou : ""} alt="rank"/>
                    <h2>
                        { players.length > 0 && players.find(pl => pl.id === data.player)?.name?.length > 7 ? players.find(pl => pl.id === data.player)?.name?.substr(0,7)+"..." : players.find(pl => pl.id === data.player)?.name  }
                    </h2>
                </div>
                <div className="secondDiv"><h1>{data.score}</h1></div>
            </div>)
            }

            <svg className="brand" xmlns="http://www.w3.org/2000/svg" width="188" height="20" viewBox="0 0 188 20" fill="none">
            <g clip-path="url(#clip0_159_596)">
                <path d="M11.9306 17.7083L2.125 0H0L10.5139 18.875C10.8611 19.5278 11 19.7083 11.375 19.8889C11.5417 19.9583 11.7083 19.9861 11.8889 19.9861C12.2639 19.9861 12.625 19.8472 12.8889 19.5833L12.9444 19.5139C12.9861 19.4444 13.0556 19.3472 13.1528 19.1944L23.8333 0H21.7083L11.9306 17.7083Z" fill="white"/>
                <path d="M26.8889 1.97223C26.3889 1.6389 25.5695 1.68056 25.1389 2.02778C24.9306 2.18056 24.7639 2.52778 24.7639 2.84723C24.7639 3.1389 24.875 3.3889 25.0972 3.56945C25.3472 3.77778 25.7084 3.8889 26.0834 3.8889C26.4306 3.8889 26.75 3.79167 26.9861 3.59723C27.2778 3.3889 27.4306 3.09723 27.4167 2.77778C27.3889 2.45834 27.1945 2.16667 26.8889 1.97223Z" fill="white"/>
                <path d="M26.9721 4.70834H25.1943V19.8195H26.9721V4.70834Z" fill="white"/>
                <path d="M32.6112 17.75C31.6806 17.1806 31.2917 16.5139 31.2917 15.4445V8.83335C31.2917 7.54168 31.5973 7.06946 32.8056 6.54168C33.3056 6.31946 33.9445 6.16668 35.4167 6.16668H43.4167V4.69446H35.2362C31.4445 4.69446 29.5278 6.1389 29.5278 8.97224V15.5417C29.5278 17.4861 30.4445 18.6806 32.5001 19.4167C33.3612 19.7083 34.1806 19.8056 35.8473 19.8056H43.5417V18.3611H35.9167C33.9862 18.375 33.3612 18.1806 32.6112 17.75Z" fill="white"/>
                <path d="M48.1945 0H46.4167V19.8194H48.1945V6.16667H53.9584V4.70833H48.1945V0Z" fill="white"/>
                <path d="M70.625 8.99998V15.7778C70.625 17.0416 70.0972 17.7083 68.7361 18.1528C68.2222 18.3194 67.8333 18.375 66.4306 18.375H61.6389C60.1389 18.375 59.75 18.3194 59.1806 18.1528C57.6806 17.6805 57.1389 17.0417 57.1389 15.7083V8.99998C57.1389 7.59721 57.6944 6.88887 59.1806 6.38887C59.7083 6.19443 60.0555 6.16665 61.625 6.16665H66.4167C68.1667 6.16665 68.6667 6.26387 69.4444 6.73609C70.3472 7.27776 70.625 7.80554 70.625 8.99998ZM66.5 4.69443H61.5972C59.375 4.69443 58.5417 4.86109 57.375 5.55554C55.8472 6.41665 55.3611 7.31943 55.3611 9.24998V15.4028C55.0694 17.2222 56.25 18.75 58.5139 19.4861C59.3056 19.7361 59.8472 19.7916 61.5972 19.7916H66.5C68.5278 19.7916 69.3472 19.625 70.5 19C71.9305 18.1528 72.4444 17.2222 72.4444 15.4444V9.26387C72.4444 6.19443 70.5 4.69443 66.5 4.69443Z" fill="white"/>
                <path d="M80.5278 4.70832C80.4028 4.72221 80.2917 4.72221 80.1667 4.72221C76.6111 4.97221 75.0417 6.31943 75.0417 9.09721L75 19.8055H76.8194V9.11109C76.8194 7.24998 77.8611 6.34721 80.2361 6.19443C80.4028 6.16665 80.5556 6.16665 80.7222 6.16665H82.5833V4.69443H80.9028C80.7778 4.69443 80.6528 4.70832 80.5278 4.70832Z" fill="white"/>
                <path d="M86.9722 1.97221C86.4722 1.65277 85.6527 1.69444 85.2222 2.02777C85.0138 2.18055 84.8472 2.52777 84.8472 2.84721C84.8472 3.13888 84.9583 3.38888 85.1805 3.55555C85.4444 3.76388 85.7916 3.87499 86.1666 3.87499C86.5138 3.87499 86.8333 3.77777 87.0694 3.58332C87.3472 3.38888 87.4999 3.09721 87.4999 2.79166C87.4861 2.45832 87.2916 2.16666 86.9722 1.97221Z" fill="white"/>
                <path d="M87.0695 4.70834H85.2917V19.8195H87.0695V4.70834Z" fill="white"/>
                <path d="M101.694 18.375H95.4443C95.236 18.375 95.0277 18.3472 94.8471 18.3195C91.9582 17.9722 91.5832 16.7639 91.5832 15.75V13.6111C91.5832 11.75 93.2777 11.1806 94.6943 11.0139C94.9027 10.9861 95.1249 10.9583 95.3332 10.9583H105.319V15.7917C105.319 18.0417 103.055 18.375 101.694 18.375ZM100.68 4.69446H89.8471V6.16668H101.278C103.875 6.16668 105.361 7.15279 105.361 8.8889V9.52779H95.4166C92.0138 9.52779 89.8193 11.1389 89.8193 13.6389V15.8056C89.861 17.9445 91.6249 19.4306 94.5416 19.75C94.8888 19.7778 95.236 19.8056 95.5416 19.8056H101.667C103.514 19.8056 104.805 19.4306 105.861 18.5833C106.819 17.7778 107.125 17.0556 107.125 15.5833V9.05557C107.139 7.90279 106.792 6.95835 106.111 6.2639C105.055 5.20835 103.278 4.69446 100.68 4.69446Z" fill="white"/>
                <path d="M133.167 10.625H121.639V1.54167H133.167C135.833 1.54167 137.778 2.68056 137.778 4.23611V7.27778C137.778 7.45833 137.778 7.65278 137.75 7.80555C137.361 9.79167 135.986 10.625 133.167 10.625ZM138.014 1.29167C136.819 0.375 135.403 0 133.125 0H119.708V19.8194H121.639V12.1806H132.972C137.236 12.1806 139.694 10.4028 139.694 7.31944V3.98611C139.694 3.31944 139.333 2.55556 138.722 1.90278C138.528 1.65278 138.278 1.44444 138.014 1.29167Z" fill="white"/>
                <path d="M153.208 18.375H146.958C146.75 18.375 146.542 18.3472 146.361 18.3195C143.472 17.9722 143.111 16.7639 143.111 15.75V13.6111C143.111 11.75 144.805 11.1806 146.222 11.0139C146.43 10.9861 146.653 10.9583 146.861 10.9583H156.847V15.7917C156.833 18.0417 154.555 18.375 153.208 18.375ZM152.194 4.69446H141.361V6.16668H152.792C155.389 6.16668 156.875 7.15279 156.875 8.8889V9.52779H146.917C143.514 9.52779 141.319 11.1389 141.319 13.6389V15.8056C141.361 17.9445 143.125 19.4306 146.042 19.75C146.389 19.7778 146.736 19.8056 147.042 19.8056H153.167C155.014 19.8056 156.292 19.4306 157.347 18.5833C158.305 17.7778 158.611 17.0556 158.611 15.5833V9.05557C158.625 7.90279 158.278 6.95835 157.597 6.2639C156.569 5.20835 154.792 4.69446 152.194 4.69446Z" fill="white"/>
                <path d="M166.333 4.70835C166.222 4.72224 166.097 4.72224 165.972 4.72224C162.417 4.97224 160.847 6.31946 160.847 9.09724L160.805 19.8056H162.625V9.11112C162.625 7.25001 163.667 6.34724 166.028 6.19446C166.194 6.16668 166.347 6.16668 166.514 6.16668H168.375V4.69446H166.694C166.583 4.69446 166.458 4.70835 166.333 4.70835Z" fill="white"/>
                <path d="M175.236 12.1945L187.069 4.69446H184.222L174.167 11.0417C173.458 11.4722 173.111 11.875 173.111 12.2778C173.111 12.4722 173.181 12.75 173.556 12.9722L184.333 19.8056H187.292L175.236 12.1945Z" fill="white"/>
                <path d="M172.167 0H170.417V19.8194H172.167V0Z" fill="white"/>
            </g>
            <defs>
                <clipPath id="clip0_159_596">
                <rect width="187.278" height="20" fill="white"/>
                </clipPath>
            </defs>
            </svg>
            {/* <img className="shareIcon remove-me" src={Share} onClick={()=> runShare()} alt="rank"/> */}

            <div className="shareIcon remove-me" onClick={()=> runShare()}>
                <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="30" cy="30" r="30" fill="white"/>
                    <path d="M37.9321 20.513C37.3431 20.513 36.8677 20.9884 36.8677 21.5774V27.3038C36.8677 27.8254 36.4419 28.2511 35.9203 28.2511H22.0761C21.5546 28.2511 21.1288 27.8254 21.1288 27.3038V21.5774C21.1288 20.9884 20.6534 20.513 20.0644 20.513C19.4754 20.513 19 20.9884 19 21.5774V27.3038C19 28.9998 20.3802 30.3799 22.0761 30.3799H35.9239C37.6198 30.3799 39 28.9998 39 27.3038V21.5774C39 20.9884 38.5246 20.513 37.9356 20.513H37.9321Z" fill="#5D5D5D"/>
                    <path d="M24.6627 19.0832L27.934 15.8119V23.9474C27.934 24.5364 28.4094 25.0118 28.9984 25.0118C29.5873 25.0118 30.0628 24.5364 30.0628 23.9474V15.8119L33.334 19.0832C33.5433 19.2925 33.813 19.3954 34.0862 19.3954C34.3594 19.3954 34.6326 19.2925 34.8384 19.0832C35.2535 18.668 35.2535 17.9939 34.8384 17.5788L30.7227 13.4631C29.7718 12.5123 28.2249 12.5123 27.2705 13.4631L23.1548 17.5788C22.7397 17.9939 22.7397 18.668 23.1548 19.0832C23.57 19.4983 24.2441 19.4983 24.6592 19.0832H24.6627Z" fill="#5D5D5D"/>
                    <path d="M15.456 42.872L16.044 42.116C16.572 42.704 17.436 43.256 18.564 43.256C19.992 43.256 20.448 42.488 20.448 41.876C20.448 40.916 19.476 40.652 18.42 40.364C17.136 40.028 15.708 39.668 15.708 38.096C15.708 36.776 16.884 35.876 18.456 35.876C19.68 35.876 20.628 36.284 21.3 36.992L20.7 37.724C20.1 37.064 19.26 36.764 18.384 36.764C17.424 36.764 16.74 37.28 16.74 38.036C16.74 38.84 17.664 39.08 18.684 39.356C19.992 39.704 21.48 40.112 21.48 41.792C21.48 42.956 20.688 44.144 18.528 44.144C17.136 44.144 16.116 43.616 15.456 42.872ZM27.7553 44H26.8553V40.184C26.8553 39.164 26.3273 38.864 25.5473 38.864C24.8513 38.864 24.1793 39.296 23.8313 39.764V44H22.9313V35.996H23.8313V39.044C24.2393 38.564 25.0312 38.06 25.9073 38.06C27.1193 38.06 27.7553 38.648 27.7553 39.908V44ZM34.0763 44H33.1763V43.34C32.6963 43.868 32.0363 44.144 31.2563 44.144C30.2723 44.144 29.2283 43.484 29.2283 42.224C29.2283 40.928 30.2723 40.316 31.2563 40.316C32.0483 40.316 32.7083 40.568 33.1763 41.108V40.064C33.1763 39.284 32.5523 38.84 31.7123 38.84C31.0163 38.84 30.4523 39.092 29.9363 39.644L29.5163 39.02C30.1403 38.372 30.8843 38.06 31.8323 38.06C33.0563 38.06 34.0763 38.612 34.0763 40.016V44ZM33.1763 42.776V41.684C32.8283 41.204 32.2163 40.964 31.5803 40.964C30.7403 40.964 30.1523 41.492 30.1523 42.236C30.1523 42.968 30.7403 43.496 31.5803 43.496C32.2163 43.496 32.8283 43.256 33.1763 42.776ZM36.7805 44H35.8805V38.204H36.7805V39.14C37.2485 38.528 37.9205 38.084 38.7125 38.084V39.008C38.6045 38.984 38.4965 38.972 38.3525 38.972C37.8005 38.972 37.0445 39.428 36.7805 39.896V44ZM39.5054 41.096C39.5054 39.416 40.7054 38.06 42.3614 38.06C44.1134 38.06 45.1454 39.428 45.1454 41.168V41.396H40.4534C40.5254 42.488 41.2934 43.4 42.5414 43.4C43.2014 43.4 43.8734 43.136 44.3294 42.668L44.7614 43.256C44.1854 43.832 43.4054 44.144 42.4574 44.144C40.7414 44.144 39.5054 42.908 39.5054 41.096ZM42.3494 38.804C41.1134 38.804 40.5014 39.848 40.4534 40.736H44.2574C44.2454 39.872 43.6694 38.804 42.3494 38.804Z" fill="#5D5D5D"/>
                </svg>
            </div>

            <button className="endBtn remove-me" onClick={()=>endAll()}>
            Start new game  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" fill="none">
  <path d="M1 3.5C0.723858 3.5 0.5 3.72386 0.5 4C0.5 4.27614 0.723858 4.5 1 4.5L1 3.5ZM11.3536 4.35356C11.5488 4.15829 11.5488 3.84171 11.3536 3.64645L8.17157 0.464467C7.97631 0.269205 7.65973 0.269205 7.46447 0.464467C7.2692 0.659729 7.2692 0.976312 7.46447 1.17157L10.2929 4L7.46447 6.82843C7.2692 7.02369 7.2692 7.34027 7.46447 7.53554C7.65973 7.7308 7.97631 7.7308 8.17157 7.53554L11.3536 4.35356ZM1 4.5L11 4.5L11 3.5L1 3.5L1 4.5Z" fill="white"/>
</svg>
            </button>
        </div>
    </div>
}
export default Results;